import React from 'react';

import { useHistory } from 'react-router-dom';
import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { updateFormValue } from '../../../actions/projects.js';

import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const ProjectNotFoundDialog = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(true);
  const history = useHistory();
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch(updateFormValue('isResponseProjectError', false));
    setOpen(false);
    history.push('/projects');
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        data-testid="project-not-found-dialog--modal"
      >
        <DialogTitle
          id="alert-dialog-title"
          data-testid="project-not-found-dialog--titleError"
        >
          {t('APP.PROJECTNOTFOUNDDIALOG.PROJECTNOTFOUNDDIALOG.PH_68B693', {
            defaultValue: 'Oups, petit problème !',
          })}
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            data-testid="project-not-found-dialog--descriptionError"
          >
            {t('APP.PROJECTNOTFOUNDDIALOG.PROJECTNOTFOUNDDIALOG.PH_0EC5A0', {
              defaultValue: 'Votre projet est inexistant ou a été supprimé !',
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            data-testid="project-not-found-dialog--returnToProjectsButton"
          >
            {t('APP.PROJECTNOTFOUNDDIALOG.PROJECTNOTFOUNDDIALOG.PH_591DEF', {
              defaultValue: 'Retour à la liste des Projets',
            })}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProjectNotFoundDialog;
